namespace $.$$ {

	export class $shm_hitalama_map_widget_float_settings_table extends $.$shm_hitalama_map_widget_float_settings_table {

		@ $mol_mem
		table() {
			return this.controlled_widget().table()!
		}

		headers_label_visible() {
			return this.table().Head_method()?.val() ? [] : super.headers_label_visible()
		}

		headers_text( next?: string ) {
			if( next === undefined ) return this.table().table_head().join( '\n' )

			const head = next
				.split( /\r?\n/ )
				.map( title => title.trim() )
				.filter( Boolean )

			this.table().table_head( head )
			return next
		}

		head_code( next?: string ) {
			return this.table().Head_method(next)?.val( next ) ?? ''
		}

		rows_code( next?: string ) {
			return this.table().Rows_method(next)?.val( next ) ?? ''
		}

		rows_limit( next?: number ) {
			return this.table().rows_limit( next )
		}

		column_visibility_options(): string[] {
			return this.table().table_head().map( String )
		}

		@ $mol_mem
		columns_visible( next?: string[] ): string[] {
			const options = this.column_visibility_options()
			if( next === undefined ) {
				const hidden = new Set( this.table().cols_hidden() )
				return options.filter( name => !hidden.has( name ) )
			}

			const visible = new Set( next )
			this.table().cols_hidden( options.filter( name => !visible.has( name ) ) )
			return options.filter( name => visible.has( name ) )
		}

		controlled_settings_content_tail() {
			return this.Map_page().Widget( this.controlled_widget().link() ).Sub().settings_content()
		}

	}

}
